module.exports = __webpack_public_path__ + "img/product_59.c4bf5e6.webp";